/* global location */
(function() {
    angular.module('emarket.commons').factory('Seo', function() {
        var conditions = {
            new: 'NewCondition',
            used: 'UsedCondition',
            damaged: 'DamagedCondition',
            refurbish: 'RefurbishedCondition'
        };
        var seo = {
            getStructuredDataCondition: function(postCondition) {
                var schemaPath = 'http://schema.org';
                var condition = conditions[postCondition] || conditions.used;
                var structuredCondition = schemaPath + '/' + condition;
                return structuredCondition;
            },
            convertImagesToStructuredData: function(images, title) {
                return images.map(function(image) {
                    return {
                        '@type': 'ImageObject',
                        name: title,
                        url: location.protocol + '//' + location.host + '/' + image.path
                    };
                });
            },
            getAddressRegion: function(province) {
                var lowerProvince = province.toLowerCase();
                var region;
                if (/santo domingo/.test(lowerProvince) || lowerProvince === 'distrito nacional') {
                    region = 'Santo Domingo';
                } else {
                    region = lowerProvince;
                }
                return region;
            },
            getStructuredDataForPost: function(post) {
                var structuredData = {
                    '@context': 'http://schema.org',
                    '@type': 'Product',
                    sku: post._id,
                    name: post.title,
                    description: post.body,
                    category: post.categorySlug,
                    offers: {
                        '@type': 'Offer',
                        price: post.prices.list,
                        priceCurrency: post.currency.code,
                        availability: 'http://schema.org/InStock',
                        availabilityStarts: post.createdAt,
                        businessFunction: 'http://purl.org/goodrelations/v1#Sell',
                        itemCondition: seo.getStructuredDataCondition(post.condition),
                        image: seo.convertImagesToStructuredData(post.images, post.title),
                        areaServed: {
                            '@type': 'Place',
                            address: {
                                '@type': 'PostalAddress',
                                addressRegion: seo.getAddressRegion(post.province.name),
                                addressLocality: post.province.name,
                                addressCountry: 'DO'
                            }
                        },
                        seller: {
                            '@type': 'Person',
                            name: post.owner.displayName,
                            address: {
                                '@type': 'PostalAddress',
                                addressRegion: seo.getAddressRegion(post.province.name),
                                addressLocality: post.province.name,
                                addressCountry: 'DO'
                            }
                        }
                    }
                };

                return structuredData;
            }
        };
        return seo;
    });
}());
